import type { MailboxInfo } from 'owa-client-types';
import { executeNaaRequestForMailboxInfo } from 'owa-nested-app-auth';
import { MsalNestedAppAuthExecutor } from './MsalNestedAppAuthExecutor';

export default function executeMsalNestedAppAuthRequest(
    mailboxInfo: MailboxInfo,
    request: string,
    origin: string,
    isTrustedOrigin: boolean,
    targetWindow: Window,
    scenarioName: string,
    callerId: string
): Promise<string> {
    return executeNaaRequestForMailboxInfo(
        MsalNestedAppAuthExecutor,
        mailboxInfo,
        request,
        origin,
        isTrustedOrigin,
        targetWindow,
        scenarioName,
        callerId
    );
}
